import App from "next/app";
import React from "react";
import FelaProvider from "~/components/fela-provider";
import get from "lodash.get";
import { getColorSet } from "~/modules/colors";

// Components
import Main from "~/layouts/main";
import { ThemeContext } from "~/context/theme";

// Global site styles
//import "~/assets/styles/index.styl";
import "~/assets/styles/index.css";

// Boot up route loading indicator
import "~/components/global/loader";

// Register client side redirect checks
import "~/modules/client-redirects";

import { DataContext } from "~/context/content";

class MyApp extends App {
    static async getInitialProps({ Component, ctx }) {
        let pageProps = {};

        if (Component.getInitialProps) {
            pageProps = await Component.getInitialProps(ctx);
        }

        return {
            pageProps
        };
    }

    render() {
        let { Component, pageProps, renderer, router } = this.props;

        const data = pageProps ? pageProps.data : {};

        const pageData = get(data, "listing_page", data);

        const pageColors = getColorSet(
            get(pageData, "acf.theme_primary_color", "sky")
        );

        return (
            <FelaProvider renderer={renderer}>
                <DataContext.Provider value={data}>
                    <ThemeContext.Provider value={pageColors}>
                        <Main className={"main"}>
                            <Component
                                {...pageProps}
                                key={
                                    typeof location !== "undefined"
                                        ? location.pathname
                                        : router.route
                                }
                            />
                        </Main>
                    </ThemeContext.Provider>
                </DataContext.Provider>
            </FelaProvider>
        );
    }
}

export default MyApp;
